var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAidropdownup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.00006C11.8686 7.9993 11.7381 8.02452 11.6163 8.07429C11.4944 8.12405 11.3836 8.19738 11.2902 8.29006L5.29019 14.2901C5.10188 14.4784 4.99609 14.7338 4.99609 15.0001C4.99609 15.2664 5.10188 15.5218 5.29019 15.7101C5.47849 15.8984 5.73388 16.0042 6.00019 16.0042C6.26649 16.0042 6.52188 15.8984 6.71019 15.7101L12.0002 10.4101L17.2902 15.7001C17.4815 15.8639 17.7276 15.9495 17.9792 15.9398C18.2309 15.93 18.4697 15.8257 18.6477 15.6476C18.8258 15.4695 18.9302 15.2308 18.9399 14.9791C18.9496 14.7274 18.864 14.4814 18.7002 14.2901L12.7002 8.29006C12.5139 8.10531 12.2625 8.00116 12.0002 8.00006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidropdownup);
export default __webpack_public_path__ + "static/media/Aidropdownup.67a81ba11f3b15604ab9d7b2f318e6ec.svg";
export { ForwardRef as ReactComponent };